import events from '../../actions/event-names';
import Config from '../../config';
import { showError, showSuccess } from '../../utils'

const initialState = {
    isListFetchCompleted: false,
    isListFetched: false,
    enduranceActivityList: [],
    isDetailsFetched: false,
    enduranceActivityDetails: "",
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
 
    //   LIST
    case `${events.GET_ENDURANCE_ACTIVITY_LIST}_PENDING`: {
        if(action.meta.page === 0) {
            state.enduranceActivityList = [];
        }
        return {
            ...state,
            isListFetched: 'PENDING',
        };
    }
    case `${events.GET_ENDURANCE_ACTIVITY_LIST}_FULFILLED`: {
        if(action.payload.data.length === 0) {
            state.isListFetchCompleted = true;
        }
        return {
            ...state,
            enduranceActivityList: [...state.enduranceActivityList, ...action.payload.data],
            isListFetched: 'FULFILLED',
        };
    }
    case `${events.GET_ENDURANCE_ACTIVITY_LIST}_REJECTED`: {
        return {
            ...state,
            isListFetched: 'REJECTED',
        };
    }


    //   DETAILS
    case `${events.GET_ENDURANCE_ACTIVITY_DETAILS}_PENDING`: {
        return {
            ...state,
            enduranceActivityDetails: "",
            isDetailsFetched: 'PENDING',
        };
    }
    case `${events.GET_ENDURANCE_ACTIVITY_DETAILS_BG}_FULFILLED`: 
    case `${events.GET_ENDURANCE_ACTIVITY_DETAILS}_FULFILLED`: {
        return {
            ...state,
            enduranceActivityDetails: action.payload.data,
            isDetailsFetched: 'FULFILLED',
        };
    }
    case `${events.GET_ENDURANCE_ACTIVITY_DETAILS}_REJECTED`: {
        return {
            ...state,
            isDetailsFetched: 'REJECTED',
        };
    }


    //  DETAILS SAVE
    case `${events.SAVE_ENDURANCE_ACTIVITY_TRANSLATIONS}_PENDING`:
    case `${events.SAVE_ENDURANCE_ACTIVITY_DETAILS}_PENDING`: {
        return {
            ...state,
            saveEnduranceActivityDetails: 'PENDING',
        };
    }
    case `${events.SAVE_ENDURANCE_ACTIVITY_TRANSLATIONS}_FULFILLED`:
    case `${events.SAVE_ENDURANCE_ACTIVITY_DETAILS}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            saveEnduranceActivityDetails: 'FULFILLED',
        };
    }
    case `${events.SAVE_ENDURANCE_ACTIVITY_TRANSLATIONS}_REJECTED`:
    case `${events.SAVE_ENDURANCE_ACTIVITY_DETAILS}_REJECTED`: {
        return {
            ...state,
            saveEnduranceActivityDetails: 'REJECTED',
        };
    }

  

    case `${events.ADD_NEW_ENDURANCE_ACTIVITY}_PENDING`: {
        return {
            ...state,
            isNewEnduranceActivityAdded: 'PENDING',
        };
    }
    case `${events.ADD_NEW_ENDURANCE_ACTIVITY}_FULFILLED`: {
        showSuccess("New endurance activity added successfully")
        return {
            ...state,
            isNewEnduranceActivityAdded: 'FULFILLED',
        };
    }
    case `${events.ADD_NEW_ENDURANCE_ACTIVITY}_REJECTED`: {
        return {
            ...state,
            isNewEnduranceActivityAdded: 'REJECTED',
        };
    }


    case `${events.DELETE_ENDURANCE_ACTIVITY}_PENDING`: {
        return {
            ...state,
            isEnduranceActivityDeleted: 'PENDING',
        };
    }
    case `${events.DELETE_ENDURANCE_ACTIVITY}_FULFILLED`: {
        showSuccess("Endurance activity deleted successfully")
        return {
            ...state,
            isEnduranceActivityDeleted: 'FULFILLED',
        };
    }
    case `${events.DELETE_ENDURANCE_ACTIVITY}_REJECTED`: {
        return {
            ...state,
            isEnduranceActivityDeleted: 'REJECTED',
        };
    }
    

    






    default:
        return state;
    }
}
